export default "__VITE_ASSET__Dc3x1IfB__"